import { type ComponentType } from 'react';

import { type AskKind } from '@/james-playground/aa-family-claim/claim/asks';
import ActivitiesCard from '@/james-playground/aa-family-claim/claim/cards/ActivitiesCard';
import AmountCard from '@/james-playground/aa-family-claim/claim/cards/AmountCard';
import ApproxDateCard from '@/james-playground/aa-family-claim/claim/cards/ApproxDateCard';
import BankCard from '@/james-playground/aa-family-claim/claim/cards/BankCard';
import ChoiceCard from '@/james-playground/aa-family-claim/claim/cards/ChoiceCard';
import ConfirmCard from '@/james-playground/aa-family-claim/claim/cards/ConfirmCard';
import ConsentCard from '@/james-playground/aa-family-claim/claim/cards/ConsentCard';
import DetailsCard from '@/james-playground/aa-family-claim/claim/cards/DetailsCard';
import DocumentsCard from '@/james-playground/aa-family-claim/claim/cards/DocumentsCard';
import FallsCard from '@/james-playground/aa-family-claim/claim/cards/FallsCard';
import HelpGridCard from '@/james-playground/aa-family-claim/claim/cards/HelpGridCard';
import NarrativeCard from '@/james-playground/aa-family-claim/claim/cards/NarrativeCard';
import NightGridCard from '@/james-playground/aa-family-claim/claim/cards/NightGridCard';
import QuickChecksCard from '@/james-playground/aa-family-claim/claim/cards/QuickChecksCard';
import QuietCard from '@/james-playground/aa-family-claim/claim/cards/QuietCard';
import RepeatCard from '@/james-playground/aa-family-claim/claim/cards/RepeatCard';
import SignerCard from '@/james-playground/aa-family-claim/claim/cards/SignerCard';
import Sr1Card from '@/james-playground/aa-family-claim/claim/cards/Sr1Card';
import StartDateCard from '@/james-playground/aa-family-claim/claim/cards/StartDateCard';
import StayCard from '@/james-playground/aa-family-claim/claim/cards/StayCard';
import SupportingCard from '@/james-playground/aa-family-claim/claim/cards/SupportingCard';
import VariabilityCard from '@/james-playground/aa-family-claim/claim/cards/VariabilityCard';
import WatchCard from '@/james-playground/aa-family-claim/claim/cards/WatchCard';
import { type CardProps } from '@/james-playground/aa-family-claim/claim/cards/types';

/** The card for each kind of ask. */
export const CARDS: Record<AskKind, ComponentType<CardProps>> = {
  confirm: ConfirmCard,
  fields: DetailsCard,
  checks: QuickChecksCard,
  choice: ChoiceCard,
  repeat: RepeatCard,
  helpGrid: HelpGridCard,
  nightGrid: NightGridCard,
  watch: WatchCard,
  falls: FallsCard,
  activities: ActivitiesCard,
  amount: AmountCard,
  approxDate: ApproxDateCard,
  stay: StayCard,
  bank: BankCard,
  signer: SignerCard,
  consent: ConsentCard,
  documents: DocumentsCard,
  quiet: QuietCard,
  startDate: StartDateCard,
  sr1: Sr1Card,
  variability: VariabilityCard,
  narrative: NarrativeCard,
  supporting: SupportingCard,
};

/**
 * One ask's answer card, picked by its kind. Key it by the ask's id where it
 * is rendered, so a new ask starts from fresh state.
 */
const AskCard = (props: CardProps) => {
  const Kind = CARDS[props.ask.kind];
  return <Kind {...props} />;
};

AskCard.displayName = 'AskCard';
export default AskCard;
